module.exports = __webpack_public_path__ + "img/help8.0824678d.jpg";